import React, { useState, useCallback } from "react";
import { useMsal } from "@azure/msal-react";
import { msalConfig } from "../config/authConfig";
import { Button, Dropdown, ButtonGroup } from "react-bootstrap";
import { LogoutMethod } from "../types/auth.types";
import { AuthError } from "@azure/msal-browser";

const LogoutButton: React.FC = () => {
  const { instance } = useMsal();
  const [loading, setLoading] = useState<boolean>(false);

  const handleLogout = useCallback(
    async (logoutType: LogoutMethod) => {
      if (loading) return;
      setLoading(true);
      const redirectUri = msalConfig.auth.postLogoutRedirectUri ?? "/";
      try {
        if (logoutType === "popup") {
          await instance.logoutPopup({
            postLogoutRedirectUri: redirectUri,
            mainWindowRedirectUri: redirectUri,
          });
        } else {
          await instance.logoutRedirect({
            postLogoutRedirectUri: redirectUri,
          });
        }
      } catch (error) {
        const authError = error as AuthError;
        if (authError.errorCode !== "interaction_in_progress") {
          console.error("Error en logout:", authError.message);
        }
      } finally {
        setLoading(false);
      }
    },
    [instance, loading]
  );

  return (
    <Dropdown as={ButtonGroup}>
      <Button
        variant="outline-light"
        size="sm"
        onClick={() => handleLogout("popup")}
        disabled={loading}
      >
        {loading ? "Cerrando..." : "Cerrar Sesión"}
      </Button>

      <Dropdown.Toggle
        split
        variant="outline-light"
        size="sm"
        id="dropdown-split-logout"
      />

      <Dropdown.Menu>
        <Dropdown.Item
          onClick={() => handleLogout("popup")}
          disabled={loading}
        >
          Logout con Popup
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => handleLogout("redirect")}
          disabled={loading}
        >
          Logout con Redirect
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LogoutButton;
